import type { RouteObject } from 'react-router';

import * as searchVolopsHorizonRouteExports from '#/modules/search/volops/page/SearchVolops.horizon-route';
import { searchVolopsRoutePaths } from '#/modules/search/volops/routing/seachVolops.route-paths';
import { horizonRouteToObject } from '#/routing/utils/horizonRouteToObject';

export const searchVolopsRouteObjects = searchVolopsRoutePaths.map((path) => ({
  path,
  ...horizonRouteToObject(searchVolopsHorizonRouteExports),
})) satisfies RouteObject[];
